import { useEffect, useRef } from "react";

const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20preciso%20de%20orientação%20jurídica.";

export default function CTASection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-cta");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToContato = () => {
    const el = document.querySelector("#contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section ref={sectionRef} className="py-24 lg:py-28 relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20law%20books%20scales%20of%20justice%20wooden%20desk%20warm%20ambient%20lighting%20professional%20legal%20office%20background%20sophisticated%20dark%20muted%20brown%20tones%20premium%20editorial&width=1920&height=600&seq=cta1&orientation=landscape"
          alt="Orientação jurídica especializada advogado"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-grafite/95 via-rose-dark/92 to-grafite/95" />
        <div className="absolute inset-0 bg-grafite/40" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="reveal-cta opacity-0 translate-y-8 transition-all duration-700 flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-10 bg-white/40" />
          <span className="text-white/70 text-xs font-medium uppercase tracking-widest">Fale Conosco</span>
          <div className="h-px w-10 bg-white/40" />
        </div>

        <h2 className="reveal-cta opacity-0 translate-y-8 transition-all duration-700 font-heading text-3xl lg:text-5xl text-white font-semibold leading-tight mb-5">
          Precisa de orientação jurídica?<br />
          <em className="not-italic font-normal text-white/85">Fale agora com um especialista.</em>
        </h2>

        <p className="reveal-cta opacity-0 translate-y-8 transition-all duration-700 text-white/70 text-base leading-relaxed max-w-xl mx-auto mb-10">
          Nossa equipe está pronta para analisar o seu caso e oferecer a melhor solução jurídica para você ou sua empresa.
        </p>

        <div className="reveal-cta opacity-0 translate-y-8 transition-all duration-700 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-white text-rose-primary hover:bg-gray-light font-semibold px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </div>
            Falar pelo WhatsApp
          </a>
          <button
            onClick={scrollToContato}
            className="flex items-center gap-2 border-2 border-white/50 hover:border-white text-white font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm hover:bg-white/10"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-send-line text-sm" />
            </div>
            Entrar em Contato
          </button>
        </div>
      </div>
    </section>
  );
}
